const Footer = () => {
  const handleAnchorClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer style={{ backgroundColor: "#1a1a1a" }} className="text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-8 sm:py-16">
        {/* 모바일: 간소화 레이아웃 */}
        <div className="block sm:hidden">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-9 h-9 bg-orange-500 rounded-lg flex items-center justify-center">
              <span className="text-white font-black text-base">SC</span>
            </div>
            <div>
              <div className="font-black text-base text-white">삼성콘크리트(주)</div>
              <div className="text-orange-400 text-xs">SAMSUNG CONCRETE</div>
            </div>
          </div>
          <div className="space-y-1.5 text-xs text-white/50 mb-5">
            <div className="flex items-start gap-2">
              <i className="ri-map-pin-2-line text-orange-400 mt-0.5 shrink-0"></i>
              <span>충북 음성군 삼성면 덕호로 543</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-phone-line text-orange-400 shrink-0"></i>
              <span>043) 883-8566</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-mail-line text-orange-400 shrink-0"></i>
              <span>ssc8566@naver.com</span>
            </div>
          </div>
          {/* 빠른 링크 */}
          <div className="flex flex-wrap gap-3 text-xs">
            {[
              { label: "제품소개", href: "#products" },
              { label: "회사소개", href: "#about" },
              { label: "시공실적", href: "#achievements" },
              { label: "견적문의", href: "#contact" },
            ].map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleAnchorClick(item.href); }}
                className="text-white/50 hover:text-orange-400 transition-colors cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>

        {/* 데스크탑: 기존 레이아웃 */}
        <div className="hidden sm:grid grid-cols-1 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-black text-lg">SC</span>
              </div>
              <div>
                <div className="font-black text-lg text-white">삼성콘크리트(주)</div>
                <div className="text-orange-400 text-xs">SAMSUNG CONCRETE</div>
              </div>
            </div>
            <p className="text-white/50 text-sm leading-relaxed mb-6 max-w-xs">
              충청북도 음성군에 위치한 블럭식 보강토 옹벽 시스템 전문 제조기업으로,
              30년 이상의 기술력과 품질로 전국 현장에 납품합니다.
            </p>
            <div className="space-y-2 text-sm">
              <div className="flex items-start gap-2 text-white/60">
                <i className="ri-map-pin-2-line text-orange-400 mt-0.5 shrink-0"></i>
                <span>충북 음성군 삼성면 덕호로 543</span>
              </div>
              <div className="flex items-center gap-2 text-white/60">
                <i className="ri-phone-line text-orange-400 shrink-0"></i>
                <span>043) 883-8566</span>
              </div>
              <div className="flex items-center gap-2 text-white/60">
                <i className="ri-mail-line text-orange-400 shrink-0"></i>
                <span>ssc8566@naver.com</span>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-bold text-white text-sm uppercase tracking-wider mb-5">제품</h4>
            <ul className="space-y-3">
              {["SC보강토 옹벽블록","SC옹벽 축조블록","SC식생 호안 축조블록","세코 옹벽 블록","레디락 옹벽 블록"].map((p) => (
                <li key={p}>
                  <a href="#products" onClick={(e) => { e.preventDefault(); handleAnchorClick("#products"); }}
                    className="text-white/50 text-sm hover:text-orange-400 transition-colors cursor-pointer">
                    {p}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-white text-sm uppercase tracking-wider mb-5">회사</h4>
            <ul className="space-y-3">
              {[
                { label: "회사소개", href: "#about" },
                { label: "시공실적", href: "#achievements" },
                { label: "견적문의", href: "#contact" },
                { label: "오시는 길", href: "#contact" },
              ].map((item) => (
                <li key={item.label}>
                  <a href={item.href} onClick={(e) => { e.preventDefault(); handleAnchorClick(item.href); }}
                    className="text-white/50 text-sm hover:text-orange-400 transition-colors cursor-pointer">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-4 sm:py-5 flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-4">
          <p className="text-white/30 text-xs">
            © 2026 삼성콘크리트(주). All rights reserved.
          </p>
          <div className="flex items-center gap-4 sm:gap-6">
            <span className="text-white/30 text-xs">개인정보처리방침</span>
            <div className="flex items-center gap-2">
              <a href="https://blog.naver.com" rel="nofollow" target="_blank" className="w-7 h-7 flex items-center justify-center border border-white/20 rounded-lg text-white/40 hover:text-orange-400 hover:border-orange-400 transition-colors cursor-pointer">
                <i className="ri-blogger-line text-xs"></i>
              </a>
              <a href="https://youtube.com" rel="nofollow" target="_blank" className="w-7 h-7 flex items-center justify-center border border-white/20 rounded-lg text-white/40 hover:text-orange-400 hover:border-orange-400 transition-colors cursor-pointer">
                <i className="ri-youtube-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
